import { render, staticRenderFns } from "./make.vue?vue&type=template&id=094b798b&scoped=true"
import script from "./make.vue?vue&type=script&lang=js"
export * from "./make.vue?vue&type=script&lang=js"
import style0 from "./make.vue?vue&type=style&index=0&id=094b798b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094b798b",
  null
  
)

export default component.exports